"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ClusterRed = function ClusterRed(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "Clustering_rot"), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12.02",
    cy: "11.9",
    r: "6.66",
    style: {
      fill: '#e4352b'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,20.5a8.6,8.6,0,0,1-6.5-3,.51.51,0,1,1,.76-.66,7.59,7.59,0,0,0,11.49,0,.51.51,0,1,1,.77.66A8.6,8.6,0,0,1,12,20.5Z",
    style: {
      fill: '#e4352b'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.67,15.07l-.17,0a.51.51,0,0,1-.31-.64,7.6,7.6,0,0,0-5.73-10,.51.51,0,0,1,.19-1,8.61,8.61,0,0,1,6.49,11.28A.51.51,0,0,1,19.67,15.07Z",
    style: {
      fill: '#e4352b'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.38,15.08a.51.51,0,0,1-.48-.34,8.61,8.61,0,0,1,6.54-11.3.51.51,0,1,1,.18,1,7.6,7.6,0,0,0-5.77,10,.51.51,0,0,1-.31.64A.5.5,0,0,1,4.38,15.08Z",
    style: {
      fill: '#e4352b'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,22.16a10.26,10.26,0,0,1-7.76-3.55A.51.51,0,0,1,5,17.95a9.25,9.25,0,0,0,14,0,.51.51,0,1,1,.77.66A10.26,10.26,0,0,1,12,22.16Z",
    style: {
      fill: '#e4352b',
      opacity: '0.8'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.23,15.62l-.17,0a.51.51,0,0,1-.31-.64,9.26,9.26,0,0,0-7-12.14.51.51,0,0,1,.19-1,10.27,10.27,0,0,1,7.75,13.46A.51.51,0,0,1,21.23,15.62Z",
    style: {
      fill: '#e4352b',
      opacity: '0.8'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.82,15.63a.51.51,0,0,1-.48-.34,10.27,10.27,0,0,1,7.8-13.48.51.51,0,1,1,.18,1A9.26,9.26,0,0,0,3.29,15,.51.51,0,0,1,3,15.6.5.5,0,0,1,2.82,15.63Z",
    style: {
      fill: '#e4352b',
      opacity: '0.8'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.36,16.13a.51.51,0,0,1-.48-.34A11.81,11.81,0,0,1,9.86.3a.51.51,0,0,1,.18,1,10.79,10.79,0,0,0-8.2,14.16.51.51,0,0,1-.31.64Z",
    style: {
      fill: '#e4352b',
      opacity: '0.7000000000000001'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,23.69A11.79,11.79,0,0,1,3.1,19.61a.51.51,0,1,1,.76-.66,10.78,10.78,0,0,0,16.33,0,.51.51,0,1,1,.77.66A11.79,11.79,0,0,1,12,23.69Z",
    style: {
      fill: '#e4352b',
      opacity: '0.7000000000000001'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.68,16.13l-.17,0a.51.51,0,0,1-.31-.64A10.79,10.79,0,0,0,14.06,1.31a.51.51,0,0,1,.19-1,11.81,11.81,0,0,1,8.91,15.48A.51.51,0,0,1,22.68,16.13Z",
    style: {
      fill: '#e4352b',
      opacity: '0.7000000000000001'
    }
  }));
};

var _default = ClusterRed;
exports["default"] = _default;